export class GlobalConstants {

    public static readonly LOGIN = 'login';
    public static readonly USER_PROFILE = 'getUserProfile';
    public static readonly NEW_USER_PROFILE = 'getNewUserDetails';
    public static readonly FETCH_QUESTIONNAIRE_LIST = 'fetchQuestionnaireList';
    public static readonly FETCH_REVIEW_QUESTIONNAIRE_LIST = 'fetchReviewQuestionnaireList';
    public static readonly FETCH_CONTROL_QUESTIONS = 'fetchControlQuestions';
    public static readonly FETCH_GENERAL_QUESTIONS = 'fetchGeneralQuestions';
    public static readonly FETCH_CATEGORIES = 'fetchCategories';
    public static readonly FETCH_SUBCATEGORIES = 'fetchSubcategories';
    public static readonly REGISTRATION = 'registration';
    public static readonly ASSESSMENT_LIST = 'fetchAssessmentList';
    public static readonly SAVE_QUES_RESPONSE = 'saveQuestionResponse';
    public static readonly UPDATE_QUES_RESPONSES = 'batchUpdateQuesResponses';
    public static readonly SUBMIT_QUES_RESPONSES = 'submitQuesResponses';
    public static readonly SAVE_QUESTIONNAIRE = 'saveQuestionnaire';
    public static readonly UPDATE_QUESTIONNAIRE_PROGRESS = 'updateQuestionnaireProgress';
    public static readonly FETCH_EXECUTOR_RESPONSE = 'fetchExecutorResponses';
    public static readonly CHECK_ALL_QUES_SUBMITTED = 'checkAllQuestionsSubmitted';
    public static readonly CHECK_ALL_QUES_REVIEWED = 'checkAllQuestionsReviewed';
    public static readonly SEND_EMAIL_WITH_OTP = 'sendEmailWithOtp';
    public static readonly FETCH_COUNTRIES = 'fetchCountries';
    public static readonly FILE_UPLOAD = 'uploadFile';
    public static readonly FILE_DELETE = 'deleteFile';
    public static readonly FETCH_RESPONSEID = 'fetchExecutorResponseId';
    public static readonly FETCH_RESPONSEIDS = 'fetchExecutorResponseIds';
    public static readonly FETCH_SUBMITTED_QUESTIONNAIRES = 'fetchSubmittedQuestionnaires';
    public static readonly FETCH_QUESTIONNAIRE_RATINGS = 'fetchQuestionnaireRatings';
    public static readonly CHECK_IF_CONTACT_EXISTS = 'checkIfContactExists';
    public static readonly CHECK_IF_USER_REQUEST_EXISTS = 'checkIfUserRequestExists';
    public static readonly SET_PASSWORD = 'changePassword';
    public static readonly FETCH_UPLOADED_FILE = 'fetchUploadedFile';
    public static readonly FETCH_UPLOADED_FILES = 'fetchUploadedFiles';
    public static readonly CREATE_CASE = 'createCase';
    public static readonly REOPEN_CASE = 'reopenCase';
    public static readonly FETCH_REJECTED_QUESTIONS = 'fetchRejectedQuestions';
    public static readonly FETCH_SUPERVISOR_REJECTED_QUESTIONS = 'fetchSupervisorRejectedQuestions';
    public static readonly FETCH_QUESTIONNAIRE_NAME = 'fetchQuestionnaireName';
    public static readonly FETCH_CASES = 'fetchAllCases';
    public static readonly FETCH_CASE_DETAILS = 'fetchCaseDetails';
    public static readonly PROGRESS_TRACKER_LIST = 'fetchProgressTrackerQuestionnaireList';
    public static readonly FETCH_TOTAL_NUMBER_OF_QUES = 'fetchTotalNumberOfQuestions';
    public static readonly FETCH_USER_GUIDANCE_DATA = 'fetcUserGuidance';
    public static readonly UPDATE_WRONG_OTP_COUNT = 'updateWrongOtpCount';
    public static readonly FETCH_ALL_QUESTIONS = 'fetchAllQuestions';
    public static readonly CHECK_SERVER_STATUS = 'checkServerStatus';
    public static readonly FETCH_ACTION_PLANS = 'fetchActionPlans';
    public static readonly FETCH_PENDING_ACTION_PLANS = 'fetchPendingActionPlans';
    public static readonly FETCH_REJECTED_ACTION_PLANS = 'fetchRejectedActionPlans';
    public static readonly FETCH_HISTORICAL_ACTION_PLANS = 'fetchHistoricalActionPlans';
    public static readonly FETCH_ACTION_ITEMS = 'fetchActionItems';
    public static readonly SAVE_ACTION_ITEM = 'saveActionItem';
    public static readonly BYPASS_QUESTION_RESPONSE_TEXT = '//NOT PART OF SUBMITTED ASSESSMENT//';
    public static readonly FETCH_USER_ASSESSMENT_ENTITIES = 'fetchUserAssessmentEntities';
    public static readonly VALIDATE_ASSESSMENT = 'ValidateAssessment';
    public static readonly START_ASSESSMENT = 'StartAssessment';
    public static readonly CONFIG = 'config';






    public static readonly supportedDocumentTypes = [
        'pdf',
        'txt',
        'doc',
        'jpeg',
        'jpg',
        'png'
    ]

    public static STATUSES = {
        DRAFT: { name: 'Draft', value: 755020000, arabic:"المسودة" },
        SUBMITTED: { name: 'Submitted', value: 755020001,arabic:"تم التقديم" },
        APPROVED: { name: 'Approved', value: 755020002 },
        REJECTED: { name: 'Rejected', value: 755020003,arabic:"تم الإرجاع" },
        MAKER_SUBMITTED: { name: 'Maker Submitted', value: 755020004 },
        CHECKER_REJECTED: { name: 'Checker Rejected', value: 755020005 },
        INSPECTOR_REJECTED: { name: 'Rejected', value: 755020013 },

    }
    public static ACTION_PLAN_ITEM_STATUSES = {
        DRAFT: { value: 755020000, name: "Draft", arabic:"المسودة" },
        IN_PROGRESS: { value: 755020001, name: "In Progress" },
        UNDER_REVIEW: { value: 755020002, name: "Under Review" },
        REJECTED: { value: 755020003, name: "Rejected",arabic:"تم الإرجاع" },
        CLOSED: { value: 755020004, name: "Closed" },
        OVERDUE: { value: 755020005, name: "Overdue" },
        TERMINATED: { value: 755020006, name: "Terminated" },
        PENDING: { value: 755020007, name: "Pending",arabic:"قيد الانتظار" },
        WARNING1: { value: 755020007, name: "Warning 1" },
        WARNING2: { value: 755020007, name: "Warning 2" },
        WARNING3: { value: 755020007, name: "Warning 3" },
        SUSPENSION: { value: 755020013, name: "Suspension" },
        STRIKEOFF: { value: 755020014, name: "strike off" },
    };

    public static USER_SESSION = {
        TIMEOUT: { MIN: 30, MILISEC: 1800000 },
        SERVER_STATUS_CHECK_FREQUENCY: { MIN: 2, MILISEC: 120000 }
    }
}
